export class RoleDto {
  id: number;
  name: string;
  numberOfOperations: number;
}
